import React, { useEffect, useState } from 'react';
import './Nav.css';
import { IoMdMenu, IoMdClose } from "react-icons/io";
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { scroller } from 'react-scroll';
import { useTranslation } from 'react-i18next';

function Nav() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const { t, i18n } = useTranslation();

    // Auto-update document direction for RTL support
    useEffect(() => {
        document.documentElement.dir = i18n.dir();
    }, [i18n.language]);

    const changeLanguage = (e) => {
        const newLang = e.target.value;
        i18n.changeLanguage(newLang).then(() => {
            window.location.reload(); 
        });
    };

    const show_menu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleScrollToSection = (targetId) => {
        if (isMenuOpen) show_menu();

        if (location.pathname === '/') {
            scroller.scrollTo(targetId, {
                smooth: true,
                duration: 900,
                offset: -50, 
            });
        } else {
            navigate('/', { state: { scrollTo: targetId } });
        }
    };

    useEffect(() => {
        if (location.pathname === '/' && location.state && location.state.scrollTo) {
            const targetId = location.state.scrollTo;
            setTimeout(() => {
                scroller.scrollTo(targetId, {
                    smooth: true,
                    duration: 900,
                    offset: -50,
                });
            }, 50); 
        }
    }, [location.pathname, location.state]); 

    return (
        <nav className="navbar" data-aos="zoom-in">
            {/* DESKTOP NAV WRAPPER - CENTERED */}
            <div className="nav-content">
                <span className="lien titre " onClick={() => handleScrollToSection("Apropos")}>{t('nav.about')}</span>
                <RouterLink to="/Galerie" className="lien titre">{t('nav.gallery')}</RouterLink>
                <span className="lien titre" onClick={() => handleScrollToSection("vh")}>{t('nav.visit')}</span>
                
                <RouterLink to="/" className="nav_logo">
                    <img src="./assets/Logo/Logo_medrassa.png" className="nav_logo_img" alt="logo" />
                </RouterLink>
                
                <span className="lien titre" onClick={() => handleScrollToSection("plan")}>{t('nav.map')}</span>
                <RouterLink to="/FAQ" className="lien titre">{t('nav.faq')}</RouterLink>
                <RouterLink to="/ContactPage" className="lien titre">{t('nav.contact')}</RouterLink>
            </div>

            {/* DESKTOP DROPDOWN - PINNED TO CORNER */}
            <select className="lang-dropdown desktop-only" onChange={changeLanguage} value={i18n.language}>
                <option value="fr">français</option>
                <option value="en">english</option>
                <option value="ar">العربية</option>
            </select>

            {/* MOBILE TOGGLE ICON */}
            {isMenuOpen ? (
                <IoMdClose className="menu-icon" onClick={show_menu} />
            ) : (
                <IoMdMenu className="menu-icon" onClick={show_menu} />
            )}

            {/* MOBILE MENU */}
            <div className={`Menu_mobile ${isMenuOpen ? 'open' : 'close'}`}>
                <div className='menu_container'>
                    <span className="lien titre" onClick={() => handleScrollToSection("Apropos")}>{t('nav.about')}</span>
                    <RouterLink to="/Galerie" className="lien titre" onClick={show_menu}>{t('nav.gallery')}</RouterLink>
                    <span className="lien titre" onClick={() => handleScrollToSection("vh")}>{t('nav.visit')}</span>
                    <span className="lien titre" onClick={() => handleScrollToSection("plan")}>{t('nav.map')}</span>
                    <RouterLink to="/FAQ" className="lien titre" onClick={show_menu}>{t('nav.faq')}</RouterLink>
                    <RouterLink to="/ContactPage" className="lien titre" onClick={show_menu}>{t('nav.contact')}</RouterLink>
                    <div className="mobile-lang-container">
                         <select className="lang-dropdown" onChange={changeLanguage} value={i18n.language}>
                            <option value="fr">Français</option>
                            <option value="en">English</option>
                            <option value="ar">العربية</option>
                        </select>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Nav;